import React from "react";

export default function Minus() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="36" rx="18" />
      <path
        d="M13.3364 17.9474L22.541 17.9467"
        stroke="#123333"
        strokeWidth="1.71818"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
